import { jsx as _jsx } from "react/jsx-runtime";
import CheckmarkFilled16 from '@carbon/icons-react/es/checkmark--filled/16';
import styled from 'styled-components';
const Wrapper = styled.div`
  color: var(--green-50);
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const CheckmarkIcon = ()=>{
    return /*#__PURE__*/ _jsx(Wrapper, {
        children: /*#__PURE__*/ _jsx(CheckmarkFilled16, {})
    });
};
